import { render, staticRenderFns } from "./VacancyDetailsCard.htm?vue&type=template&id=005a31cd&scoped=true&"
import script from "./VacancyDetailsCard.ts?vue&type=script&lang=js&"
export * from "./VacancyDetailsCard.ts?vue&type=script&lang=js&"
import style0 from "./VacancyDetailsCard.scss?vue&type=style&index=0&id=005a31cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005a31cd",
  null
  
)

export default component.exports